/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import FieldWrapper from './_FieldWrapper.vue';
import { validate } from '../helpers';

export const common = {
  computed: {
    isValid() {
      return validate({
        type: this.type,
        required: this.required,
        text: this.value,
        options: this.options,
      });
    },
    validationClass() {
      if (!this.touched) return '';
      return this.isValid ? 'is-valid' : 'is-invalid';
    },
  },
  props: {
    description: String,
    id: {
      type: Number,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    touched: Boolean,
    value: null,
    fieldWrapper: {
      type: [Object, String],
      default: () => FieldWrapper,
    },
  },
};

export const validationOnBlur = {
  methods: {
    handleBlur() {
      this.$emit('touch');
    },
  },
};
